import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import CustomSidePanel from "../../../components/blank-side-pannel/custom-side-pannel";
import { BlueGradientButton } from "../../../components/button";
import CustomSwitch from "../../../components/custom-form/switch";
import { DropdownWithApiSearch } from "../../../components/dropdowns/DropdownWithApiSearch";
import RegulationsDropdown from "../../../components/specific/dropdowns/RegulationsDropdown";
import * as gatewayAndPriceActions from "../store/actions/gateway_and_price_list_actions";

export default function GatewayAndPriceSidePanel({ show, gatewayAndPriceData, loadingData, handleClose }) {
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    const { domesticGateway, internationalGateway, price, regulations, isUserApprovedSenderId } = gatewayAndPriceData;
    const { inr: priceINR, usd: priceUSD } = price || {};
    const { international: priceINRInternational, domestic: priceINRDomestic } = priceINR || {};
    const { international: priceUSDInternational, domestic: priceUSDDomestic } = priceUSD || {};
    const tempFormData = {
      domesticGateway,
      internationalGateway,
      priceINRInternational,
      priceINRDomestic,
      priceUSDInternational,
      priceUSDDomestic,
      regulations,
      isApplyForAllUsers: false,
      isUserApprovedSenderId,
    };
    setFormData(tempFormData);
  }, [gatewayAndPriceData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id: gatewayAndPriceData._id,
      loadingData,
      data: {
        updateData: {
          domesticGateway: formData.domesticGateway,
          internationalGateway: formData.internationalGateway,
          price: {
            inr: {
              international: formData.priceINRInternational,
              domestic: formData.priceINRDomestic,
            },
            usd: {
              international: formData.priceUSDInternational,
              domestic: formData.priceUSDDomestic,
            },
          },
          regulations: formData.regulations,
          isUserApprovedSenderId: formData.isUserApprovedSenderId
        },
        isApplyForAllUsers: formData.isApplyForAllUsers,
        isUserApprovedSenderId: formData.isUserApprovedSenderId,
      },
    };
    dispatch(gatewayAndPriceActions.editGatewayAndPriceRequest(payload));
    handleClose();
  };
  const handleChange = (inputKey, inputValue) => {
    setFormData((prev) => {
      return {
        ...prev,
        [inputKey]: inputValue,
      };
    });
  };
  return (
    <CustomSidePanel
      show={show}
      title={"Country Name: " + gatewayAndPriceData.countryName}
      moduleName="Gateway And Price"
      handleClose={handleClose}
      customStyles={{
        width: "50vw",
        right: "51vw",
      }}
    >

      <div className="card-header d-flex flex-stack align-items-center">
        <h3 className="card-title fw-bolder text-dark">{`Country Name: ${gatewayAndPriceData.countryName}`}</h3>
      </div>
      <div style={{ height: "calc(100vh - 70px)", overflowY: "auto" }} className="p-8">
        <FormDisplay {...{ formData, handleChange, handleClose, handleSubmit }} />
      </div>
    </CustomSidePanel>
  );
}

const FormDisplay = ({ formData, handleChange, handleClose, handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Row>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Domestic Gateway</label>
          <DropdownWithApiSearch
            label={formData.domesticGateway}
            apiObjFunc={(searchText) => {
              return {
                url: "/user-service/api/super-admin/campaign/sms/gateway-names/search",
                query: { searchText },
              };
            }}
            mapOptions={(searchResults) =>
              searchResults.map((v) => {
                return { label: v.gatewayName, value: v.gatewayName };
              })
            }
            handleSelect={(selected) => handleChange("domesticGateway", selected.label)}
          />
        </Col>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">International Gateway</label>
          <DropdownWithApiSearch
            label={formData.internationalGateway}
            apiObjFunc={(searchText) => {
              return {
                url: "/user-service/api/super-admin/campaign/sms/gateway-names/search",
                query: { searchText },
              };
            }}
            mapOptions={(searchResults) =>
              searchResults.map((v) => {
                return { label: v.gatewayName, value: v.gatewayName };
              })
            }
            handleSelect={(selected) => handleChange("internationalGateway", selected.label)}
          />
        </Col>
      </Row>
      <Row>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">International Price (INR)</label>
          <Form.Control type="number" value={formData.priceINRInternational ?? 0} onChange={(e) => handleChange("priceINRInternational", e.target.value)} />
        </Col>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Domestic Price (INR)</label>
          <Form.Control type="number" value={formData.priceINRDomestic ?? 0} onChange={(e) => handleChange("priceINRDomestic", e.target.value)} />
        </Col>
      </Row>
      <Row>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">International Price (USD)</label>
          <Form.Control type="number" value={formData.priceUSDInternational ?? 0} onChange={(e) => handleChange("priceUSDInternational", e.target.value)} />
        </Col>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Domestic Price (USD)</label>
          <Form.Control type="number" value={formData.priceUSDDomestic ?? 0} onChange={(e) => handleChange("priceUSDDomestic", e.target.value)} />
        </Col>
      </Row>
      <Form.Group>
        <Form.Label>Regulations</Form.Label>
        <RegulationsDropdown values={formData.regulations || []} handleChange={(values) => handleChange("regulations", values)} />
      </Form.Group>
      <Form.Group>
        <CustomSwitch
          label="Apply for all users"
          id="apply-for-all-users"
          checked={formData.isApplyForAllUsers}
          handleChange={(e) => {
            handleChange("isApplyForAllUsers", e.target.checked);
          }}
        />
      </Form.Group>
      <Form.Group>
        <CustomSwitch
          label="User Approved Sender ID"
          id="user-approved-sender-id"
          checked={formData.isUserApprovedSenderId ?? true}
          handleChange={(e) => {
            handleChange("isUserApprovedSenderId", e.target.checked);
          }}
        />
      </Form.Group>
      <Form.Group className="d-flex gap-3 mt-10">
        <Button type="button" size="sm" variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <BlueGradientButton size="sm" type="submit">
          Save
        </BlueGradientButton>
      </Form.Group>
    </Form>
  );
};
